export default [
    {
        label: 'Accueil',
        to: '/',
        dataCy: '',
    },
    {
        label: 'Téléconsultations',
        to: '/planned-consultations',
        dataCy: 'plannedTlcTab',
    },
    {
        label: 'Téléexpertises',
        to: '/teleexpertises',
        dataCy: 'teleexpertisesTab',
    },
    {
        label: 'Patients',
        to: '/patients',
        dataCy: 'patientTab',
    },
]
